<template>
    <div
        class="parent_user_status_icon"
        :class="{ small }"
        :style="{ backgroundColor: color }"
        :title="title"
    >
        <i
            class="icon icon-inverse"
            :class="classes"
        ></i>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
        },
        spinning: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        status: {
            type: String,
            required: false,
        },
        small: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        classes() {
            let classes = [];
            classes.push('icon-' + this.icon);
            if (this.spinning) {
                classes.push('icon-pulse');
            }

            return classes;
        },
        icon() {
            if (this.spinning) {
                return 'spinner';
            }

            switch (this.status) {
                case 'signed_up':
                    return 'user-plus';

                case 'on_waiting_list':
                    return 'list';

                case 'waiting_for_contract_signing':
                    return 'pencil';

                case 'waiting_for_contract_start':
                    return 'clock';

                case 'active':
                    return 'check';

                case 'archived':
                    return 'close';

            }

            return 'circle-o';
        },
        color() {
            if (this.disabled) {
                return '#cbcbcb';
            }

            switch (this.status) {
                case 'signed_up':
                    return '#cbcbcb';

                case 'on_waiting_list':
                case 'waiting_for_contract_signing':
                case 'waiting_for_contract_start':
                    return '#FFC107';

                case 'active':
                    return '#4CAF50';

                case 'archived':
                    return '#F44336';
            }

            return '#cbcbcb';
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.parent_user_status_icon {
    margin: 8px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: calc(0.867 * var(--kgr-font-size-text));
    border-radius: 50%;
    &.small {
        width: 23px;
        height: 23px;
    }
}
</style>
